import {
  FETCH_KITCHEN_ORDERS,
  FETCH_KITCHEN_ORDERS_SUCCESS,
  FETCH_KITCHEN_ORDERS_FAILURE,
  MARK_KITCHEN_ORDER_SERVED,
  MARK_KITCHEN_ORDER_SERVED_SUCCESS,
  MARK_KITCHEN_ORDER_SERVED_FAILURE,
} from "./constants";

const initialState = {
  isFetching: false,
  servingResidentId: null,
  date: null,
  service: null,
  menu: null,
  summary: null,
  residents: [],
  // Wave 3: the home's meal sittings, when the board payload carries them.
  sittings: null,
  sittingsLocationId: null,
  error: null,
};

const KitchenOrdersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_KITCHEN_ORDERS:
      return { ...state, isFetching: true, error: null };
    case FETCH_KITCHEN_ORDERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        servingResidentId: null,
        date: action.payload?.date ?? null,
        service: action.payload?.service ?? null,
        menu: action.payload?.menu ?? null,
        summary: action.payload?.summary ?? null,
        residents: action.payload?.residents ?? [],
        sittings: Array.isArray(action.payload?.sittings)
          ? action.payload.sittings
          : null,
        sittingsLocationId: action.payload?.locationId ?? null,
      };
    case FETCH_KITCHEN_ORDERS_FAILURE:
      return { ...state, isFetching: false, error: true };
    case MARK_KITCHEN_ORDER_SERVED:
      return {
        ...state,
        servingResidentId: action.payload?.residentId ?? null,
      };
    case MARK_KITCHEN_ORDER_SERVED_SUCCESS:
      return state;
    case MARK_KITCHEN_ORDER_SERVED_FAILURE:
      return { ...state, servingResidentId: null };
    default:
      return state;
  }
};

export default KitchenOrdersReducer;
